// EventModal.tsx
import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import logo from "../images/sharifLogo.jpg";
const EventModal = ({ open, handleClose }) => {
  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      {" "}
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          background: "#FFFFFF",
          color: "white",
          p: 2,
        }}
      >
        {" "}
        <Box display="flex" alignItems="center">
          {" "}
          <img
            src={logo}
            alt="Sharif Hidayat Logo"
            style={{ height: 40, marginRight: 16 }}
          />{" "}
          <Typography variant="h6">
            {" "}
            Sharif Hidayat for Congress – Campaign Announcement{" "}
          </Typography>{" "}
        </Box>{" "}
        <IconButton onClick={handleClose} sx={{ color: "white" }}>
          {" "}
          <CloseIcon />{" "}
        </IconButton>{" "}
      </DialogTitle>{" "}
      <DialogContent sx={{ background: "#f9f9f9", color: "#222", p: "24px!important" }}>
        {" "}
        <Typography
          gutterBottom
          variant="subtitle2"
          color="textSecondary"
          sx={{ fontWeight: 500 }}
        >
          {" "}
          July 22, 2025 <br></br> info@sharifbrewster.com <br></br> (404) 726-5895{" "}
        </Typography>
        <Typography variant="h6" gutterBottom fontWeight={700} my={3}>
          {" "}
          FORMER CAPITOL HILL STAFFER AND GEORGIA NATIVE, SHARIF BREWSTER
          DECLARES CANDIDACY FOR CONGRESS IN GA-13, CALLING FOR NEW GENERATION
          OF LEADERSHIP{" "}
        </Typography>
        <Typography paragraph>
          {" "}
          Former Capitol Hill staffer, Georgia native and community champion
          Sharif Hidayat today launched his campaign for Congress in Georgia’s
          13th District, declaring the district’s need for energized and engaged
          representation in Washington.{" "}
        </Typography>
        <Typography paragraph>
          {" "}
          “In this dangerous time — our district deserves more from our
          leaders,” Hidayat declared. “It needs new energy, a new leader who
          will be the voice for the voiceless, an advocate who will stand up for
          the least of these and fight for everyone, new leadership that will
          fight for our community and our democracy. We need leaders who will
          make sure that you not only have a seat at the table, but that your
          voice is heard. Leaders who will listen—to the people —and who will
          stand up for what’s right, who will stand up for justice and fight
          back against attacks on our health care and our economy.”{" "}
        </Typography>
        <Typography paragraph>
          {" "}
          Hidayat’s call for new leadership is backed by a lifetime of service
          rooted in community. Raised in public housing in Newnan by a single
          mother and his grandparents, he knows firsthand the struggles facing
          many families in the district. His lived experience has fueled a
          career dedicated to creating economic opportunity and fighting for
          financial justice.{" "}
        </Typography>
        <Typography paragraph>
          {" "}
          His policymaking expertise was honed on Capitol Hill, where he served
          as a Policy Advisor on the U.S. House Committee on Financial Services
          under Congresswoman Maxine Waters and later worked for Senator Raphael
          Warnock. He worked on national policies protecting consumers and small
          businesses and expanding economic opportunities — experience he says
          is vital to serve the 13th district. He now helps innovative companies
          expand credit access to working families in rural and underserved
          communities, directly tackling the economic disparities that hold
          people back.{" "}
        </Typography>
        <Typography paragraph>
          {" "}
          “My commitment to Georgia families is personal," said Hidayat. "From
          delivering Meals on Wheels as a high school student at Newnan High to
          help feed our seniors, to serving as Chair of the Coweta County
          Accountability Courts to help those struggling with addiction, to
          supporting small businesses during the pandemic, I have consistently
          shown up to do the work of serving others.”{" "}
        </Typography>
        <Typography paragraph>
          {" "}
          As a first-generation college graduate from Howard University, Hidayat
          has defied barriers and is now committed to ensuring those same
          opportunities are available to every family in the 13th District.{" "}
        </Typography>
        <Typography paragraph>
          {" "}
          “I will fight for everyone in our district - every day and in every
          way - from our seniors to our children, from our teachers to our
          veterans, from our public servants to our small businesses - to ensure
          that working families in GA-13 have an equal, fair opportunity to
          thrive. That’s why I am running for Congress.”{" "}
        </Typography>
        <Typography paragraph>
          {" "}
          Hidayat's campaign will be a dynamic force for change, focused on
          bringing a new generation of energetic, results-driven leadership to
          Washington to fight for Georgia's 13th District.{" "}
        </Typography>
      </DialogContent>{" "}
    </Dialog>
  );
};
export default EventModal;
